import { Component,  Input, Output, EventEmitter } from '@angular/core';
import { SocialLink } from 'globals/store/performers.data';
import { SocialLinksData, SocialLinksDialogComponent } from 'src/app/components/social-links/socialLinks.dialog.component';
import { getXYFromEventAndWidth } from '../../helpers/helpers';
import { openDialogGetResult } from 'src/app/helpers/angular-helpers';
import { MatDialog } from '@angular/material/dialog';
import { SocialLinksComponent } from 'src/app/components/social-links/social-links.component';
import { AddManageWrapperComponent } from 'src/app/components/wrappers/add-manage-wrapper.component';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'manage-social',
    template: `
<add-manage-wrapper 
  class="social-open" 
  [hideHRule]="true" 
  [wrapperTitle]="hideTitle ? '' : 'Social'"
  [useH3ForTitle]="true" 
  [openLabel]="!links?.length ? '+ ADD A SOCIAL LINK' : 'MANAGE SOCIAL LINKS'" 
  (open)="openSocialLinks($event)"
>
  <social-links *ngIf="links?.length" [socialLinks]="links"></social-links>
  <div class="empty-text" *ngIf="!links?.length">
    No social links
  </div>
</add-manage-wrapper>
`,
    standalone: true,
    imports: [SocialLinksComponent, AddManageWrapperComponent, CommonModule],
})
export class ManageSocialLinksComponent {
  @Input() links: SocialLink[]
  @Input() hideTitle = false
  @Output() saveLinks: EventEmitter<SocialLink[]> = new EventEmitter()

  constructor(private dialog: MatDialog) {}

  openSocialLinks(event) {
    const previousSocial = JSON.stringify(this.links || [])
    const data: SocialLinksData = { social: this.links, ...getXYFromEventAndWidth(event, 300) }
    openDialogGetResult(this.dialog, SocialLinksDialogComponent, { width: '300px', data, disableClose: true, panelClass: 'vertical-center' }).then(_ => {
      if (previousSocial !== JSON.stringify(data.social)) {
        this.saveLinks.emit(data.social)
      }
    })
  }

}

